export default async function excel() {
  window.Excel.run(context => {
    return context.workbook.worksheets.getActiveWorksheet()
  })
}
